"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M184 129.4c-8.2-8.1-8.2-21.3-.1-29.5l51.6-52.1c3.9-4 9.2-6.2 14.8-6.2h.1c5.6 0 10.9 2.3 14.8 6.2l52.1 53.1c8.1 8.2 7.9 21.4-.3 29.5-4.1 4-9.3 6-14.6 6-5.4 0-10.8-2.1-14.9-6.2l-16.4-16.7v74c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8v-74.3l-16 16.1c-8.1 8.2-21.3 8.2-29.5.1zm103.5 240.4l-16.4 16.7v-74c0-11.5-9.3-20.8-20.8-20.8s-20.8 9.3-20.8 20.8v74.3l-16-16.1c-8.1-8.2-21.3-8.2-29.5-.1s-8.2 21.3-.1 29.5l51.6 52.1c3.9 4 9.2 6.2 14.8 6.2h.1c5.6 0 10.9-2.3 14.8-6.2l52.1-53.1c8.1-8.2 7.9-21.4-.3-29.5-8.3-8.1-21.5-8-29.5.2zm-173.8-98.7H188c11.5 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-74l16.7-16.4c8.2-8.1 8.3-21.2.3-29.5-8.1-8.2-21.2-8.3-29.5-.3l-53.1 52.1c-4 3.9-6.2 9.2-6.2 14.8 0 5.6 2.2 10.9 6.2 14.9l52.1 51.6c4.1 4 9.4 6 14.7 6 5.4 0 10.7-2.1 14.8-6.2 8.1-8.2 8-21.4-.1-29.5l-16.2-15.9zm338.9-35.7l-53.1-52.1c-8.2-8.1-21.4-7.9-29.5.3-8.1 8.2-7.9 21.4.3 29.5l16.7 16.4h-74c-11.5 0-20.8 9.3-20.8 20.8s9.3 20.8 20.8 20.8h74.3l-16.1 16c-8.2 8.1-8.2 21.3-.1 29.5 4.1 4.1 9.4 6.2 14.8 6.2 5.3 0 10.6-2 14.7-6l52.1-51.6c4-3.9 6.2-9.3 6.2-14.9-.1-5.7-2.3-11-6.3-14.9z"
  });
};

exports.default = _default;